import React, { useState } from "react";
import "./HotelGuestDropDown.scss";
import InputBox from "../../components/InputBox";
import CustomButton from "../../components/CustomButton";

const buttonList = [
  {
    id: 1,
    label: "Adults",
    name: "adultCount",
  },
  {
    id: 2,
    label: "Children",
    name: "childrenCount",
  },
  {
    id: 3,
    label: "Rooms",
    name: "roomCount",
  },
];
const HotelGuestDropDown = ({
  count,
  handleCountClick,
  handleGuestApplyBtn,
  handleGuestReset,
  customClass,
}) => {
  const handleClick = (e) => {
    e.stopPropagation();
  };
  return (
    <div className={`HotelGuestDropDown ${customClass}`} onClick={handleClick}>
      {buttonList.map((data) => {
        return (
          <div className="HotelGuestDropDown__container-1" key={data.id}>
            <p>{data.label}</p>
            <div className="btn-wrapper">
              <span
                class="material-symbols-outlined add-icon"
                onClick={() => handleCountClick(data.name, "sub")}
              >
                remove
              </span>
              <InputBox
                customClass="guest-count-input"
                name={data.name}
                value={count[data.name]}
              />
              <span
                class="material-symbols-outlined sub-icon"
                onClick={() => handleCountClick(data.name, "add")}
              >
                add
              </span>
            </div>
          </div>
        );
      })}
      <div className="HotelGuestDropDown__button-wrapper">
        <p className="reset-text" onClick={handleGuestReset}>
          RESET
        </p>
        <CustomButton
          type="submit"
          value="Apply"
          onClick={handleGuestApplyBtn}
        />
      </div>
    </div>
  );
};

export default HotelGuestDropDown;
